export default {
	isLoading(state, isLoading) {
		state.isLoading = isLoading;
	},
	clientSettings(state, clientSettings) {
		state.clientSettings = clientSettings;
	},
	clientDetails(state, clientDetails) {
		state.clientDetails = clientDetails;
	},
	userClasses(state, userClasses) {
		state.userClasses = userClasses;
	},
	userClassId(state, userClassId) {
		state.userClassId = userClassId;
	},
	userClassLocations(state, userClassLocations) {
		state.userClassLocations = userClassLocations;
	},
	selectedLocation(state, selectedLocation) {
		state.selectedLocation = selectedLocation;
	},
	selectedAssetLocations(state, selectedAssetLocations) {
		state.selectedAssetLocations = selectedAssetLocations;
	},
	selectedAssetLocation(state, selectedAssetLocation) {
		state.selectedAssetLocation = selectedAssetLocation;
	},
	selectedDate(state, selectedDate) {
		state.selectedDate = selectedDate;
	},
	openingHoursForDate(state, { openingHoursForDate, date }) {
		state.openingHoursForDate[date] = openingHoursForDate;
	},
	roomDetailsById(state, { roomDetailsById, room }) {
		state.roomDetailsById[room] = roomDetailsById;
	},
	currentRooms(state, currentRooms) {
		state.currentRooms = currentRooms;
	},
	assetCategory(state, { assetCategory, id }) {
		const t = state.assetCategory.filter(o => o.id !== id);
		assetCategory.id = parseInt(id);
		t.push(assetCategory);
		state.assetCategory = t;
	},
	asset(state, { asset, id }) {
		const t = state.asset.filter(o => o.id !== id);
		asset.id = parseInt(id);
		t.push(asset);
		state.asset = t;
	},
	assetGroup(state, { assetGroup, id }) {
		const t = state.assetGroup.filter(o => o.id !== id);
		assetGroup.id = parseInt(id);
		t.push(assetGroup);
		state.assetGroup = t;
	},
	assetType(state, { assetType, id }) {
		state.assetType = assetType;
	},
	HTMLWidget(state, { HTMLWidget, id }) {
		const t = state.HTMLWidget.filter(o => o.id !== id);
		t.push({ html: HTMLWidget, id: parseInt(id) });
		state.HTMLWidget = t;
	},
	locations(state, locations) {
		state.locations = locations;
	},
	showMap(state, showMap) {
		state.showMap = showMap;
	}
};
